import {combineReducers} from 'redux'
import types from 'actions/types'
import {get} from "lodash"

export const tfaQRCodeError = (state = null, action) => {
  switch (action.type) {
    case types.TFA_GET_QR_CODE_FAILURE:
      return action.message
    case types.TFA_GET_QR_CODE_ATTEMPT:
    case types.TFA_GET_QR_CODE_SUCCESS:
      return null
    default:
      return state
  }
}

export const isEnableTfaError = (state = false, action) => {
  switch (action.type) {
    case types.TFA_ENABLE_FAILURE:
      return true
    case types.TFA_ENABLE_SUCCESS:
    case types.TFA_ENABLE_ATTEMPT:
    case types.TFA_CLEAR_ENABLE_ERROR:
      return false
    default:
      return state
  }
}

export const tfaQRCode = (state = '', action) => {
  switch (action.type) {
    case types.TFA_GET_QR_CODE_SUCCESS:
      return action?.data
    case types.TFA_GET_QR_CODE_ATTEMPT:
    case types.TFA_GET_QR_CODE_FAILURE:
      return ''
    default:
      return state
  }
}

export const isLoadingTfaCode = (state = false, action) => {
  switch (action.type) {
    case types.TFA_GET_QR_CODE_SUCCESS:
    case types.TFA_GET_QR_CODE_FAILURE:
      return false
    case types.TFA_GET_QR_CODE_ATTEMPT:
      return true
    default:
      return state
  }
}

export const isEnablingTfa = (state = false, action) => {
  switch (action.type) {
    case types.TFA_ENABLE_SUCCESS:
    case types.TFA_ENABLE_FAILURE:
      return false
    case types.TFA_ENABLE_ATTEMPT:
      return true
    default:
      return state
  }
}

export const isShowTfaSetup = (state = false, action) => {
  switch (action.type) {
    case types.OPEN_TFA_SETUP:
      return true
    case types.CLOSE_TFA_SETUP:
    case types.TFA_ENABLE_SUCCESS:
    case types.DISMISS_TFA_PROMPT_SUCCESS:
      return false
    default:
      return state
  }
}

export const isIncludeTfaIntroDialog = (state = true, action) => {
  switch (action.type) {
    case types.OPEN_TFA_SETUP:
      return get(action, 'includeIntroDialog')
    default:
      return state
  }
}

export const isShowTfaLoginForm = (state = false, action) => {
  switch (action.type) {
    case types.SHOW_TFA_LOGIN_FORM:
      return true
    case types.HIDE_TFA_LOGIN_FORM:
      return false
    default:
      return state
  }
}

export const isTotpAuthenticateError = (state = false, action) => {
  switch (action.type) {
    case types.AUTHENTICATE_TOTP_LOGIN_FAILURE:
      return true
    case types.AUTHENTICATE_TOTP_LOGIN_SUCCESS:
    case types.AUTHENTICATE_TOTP_LOGIN_ATTEMPT:
      return false
    default:
      return state
  }
}

export default combineReducers({
  tfaQRCode,
  tfaQRCodeError,
  isEnableTfaError,
  isLoadingTfaCode,
  isEnablingTfa,
  isShowTfaSetup,
  isIncludeTfaIntroDialog,
  isShowTfaLoginForm,
  isTotpAuthenticateError,
})
